import { render, staticRenderFns } from "./FormJustificativaFaltaDialog.vue?vue&type=template&id=41facab2&scoped=true"
import script from "./FormJustificativaFaltaDialog.vue?vue&type=script&lang=js"
export * from "./FormJustificativaFaltaDialog.vue?vue&type=script&lang=js"
import style0 from "./FormJustificativaFaltaDialog.vue?vue&type=style&index=0&id=41facab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41facab2",
  null
  
)

export default component.exports